import * as mobx from 'mobx';
import TrackingService from '.';

class TrackingServiceProvider {
    @mobx.observable
    public trackingServiceProvider: TrackingService;
    constructor() {
        this.trackingServiceProvider = new TrackingService();
    }

    public get = (): TrackingService => {
        return this.trackingServiceProvider;
    };
}

export default TrackingServiceProvider;
